import React, { useState, useEffect } from 'react';
import { Building } from 'lucide-react';

interface TenantCardContentProps {
  tenant: {
    name: string;
    tenant_code: string;
    logo_url?: string;
  };
}

const TenantCardContent: React.FC<TenantCardContentProps> = ({ tenant }) => {
  const [logoError, setLogoError] = useState(false);
  const [processedLogoUrl, setProcessedLogoUrl] = useState<string | undefined>(undefined);
  
  // Process logo URL when tenant changes
  useEffect(() => {
    if (tenant.logo_url) {
      // Check if it's already a data URL (base64)
      if (tenant.logo_url.startsWith('data:')) {
        setProcessedLogoUrl(tenant.logo_url);
      } else {
        // If it's a regular URL
        setProcessedLogoUrl(tenant.logo_url);
      }
      
      // Reset error state
      setLogoError(false);
    } else {
      setProcessedLogoUrl(undefined);
    }
  }, [tenant]);
  
  return (
    <div className="flex items-center w-full">
      <div className="w-8 h-8 mr-3 flex-shrink-0 rounded-md overflow-hidden border border-gray-700 bg-white flex items-center justify-center">
        {processedLogoUrl && !logoError ? (
          <img 
            src={processedLogoUrl} 
            alt={tenant.name}
            className="w-full h-full object-contain"
            onError={(e) => {
              console.error(`Error loading logo for tenant ${tenant.name}:`, e);
              setLogoError(true);
            }}
          />
        ) : (
          <Building size={18} className="text-gray-500" />
        )}
      </div>
      <div className="min-w-0 w-full overflow-hidden">
        <h3 className="font-medium text-sm overflow-hidden text-ellipsis whitespace-nowrap w-full">{tenant.name}</h3>
        <code className="text-xs bg-opacity-30 bg-gray-800 px-1.5 py-0.5 rounded border border-gray-700 mt-0.5 inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap">{tenant.tenant_code}</code>
      </div>
    </div>
  );
};

// Export with memo to prevent unnecessary re-renders
export default React.memo(TenantCardContent); 